import React, { useContext } from 'react';
import SectionBlock from './SectionBlock';
import { IconRadiusL } from '../../../icons';
import { MatchingDialogContext } from '../configs';
import {
    resolveRadiusDescriptionHorse,
    resolveRadiusDescriptionRider,
    showSection,
} from '../utils';
import config from '../../../config';
import { trimDisplayNameLastWord } from '../../../util/text';

const {
    listingTypeHorse,
    listingTypeRider,
    listingTypePrivateHorse,
    listingTypePrivateRider,
} = config;

const SectionRadius = () => {
    const { scoreData, categorySelected, currentPageListing, riderListing } = useContext(
        MatchingDialogContext
    );
    const scoreLocationData = scoreData?.baseScoreBreakdown?.distanceAndMobilityScore;

    if (!scoreLocationData) return null;

    const { radiusScore } = scoreLocationData || {};
    const radiusScoreData = { maxScore: 10, total: radiusScore };

    const { title, publicData } = currentPageListing?.attributes || {};
    const { type } = publicData || {};

    const isHorseListing = type === listingTypeHorse || type === listingTypePrivateHorse;
    const isRiderListing = type === listingTypeRider || type === listingTypePrivateRider;

    const radius = riderListing?.attributes?.publicData?.user_mobility?.radius;

    if (!radius) return null;

    const { isHighScore, isLowScore, shouldBeShown } = showSection({
        categorySelected,
        ...radiusScoreData,
    });

    const radiusNum = parseInt(radius);

    if (!shouldBeShown) return null;

    const descriptionResolver = isHorseListing
        ? resolveRadiusDescriptionRider
        : resolveRadiusDescriptionHorse;

    const description = descriptionResolver({
        isHighScore,
        isLowScore,
        title: isRiderListing ? trimDisplayNameLastWord(title) : title,
        radius: radiusNum,
    });

    return (
        <SectionBlock scoreData={scoreData}>
            <SectionBlock.Header>
                <IconRadiusL />
                <span>Standort & Radius</span>
            </SectionBlock.Header>
            <SectionBlock.ScoreBadge sectionScoreData={radiusScoreData} />
            <SectionBlock.Description>{description}</SectionBlock.Description>
        </SectionBlock>
    );
};

export default SectionRadius;
